export default __webpack_public_path__ + "static/media/5.817f12b5.jpg";